import { config } from 'core/config';
import { FeatureDefinition } from '../entities';

export const web2AppLinkFeature = 'appnebula_web2app_link';

export const web2AppLinkFeatureConfig: FeatureDefinition = {
  defaultValue: config.web2appLink,
};
